const INIT_STATE = {
  show: false,
  infos: [],
  errors: [],
  data: {},
};

export function CreateXeroAccountModalReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case 'SHOW_XERO_ACCOUNT_MODAL': {
      return {
        ...state,
        show: true,
      };
    }
    case 'HIDE_XERO_ACCOUNT_MODAL': {
      return {
        ...state,
        show: false,
      };
    }
    case 'SET_INFO_XERO_ACCOUNT_MODAL': {
      return {
        ...state,
        infos: action.payload,
      };
    }
    case 'CLEAR_INFO_XERO_ACCOUNT_MODAL': {
      return {
        ...state,
        infos: [],
      };
    }
    case 'SET_ERROR_XERO_ACCOUNT_MODAL': {
      return {
        ...state,
        errors: action.payload,
      };
    }
    case 'CLEAR_ERROR_XERO_ACCOUNT_MODAL': {
      return {
        ...state,
        errors: [],
      };
    }
    case 'SET_DATA_XERO_ACCOUNT_MODAL': {
      return {
        ...state,
        data: action.payload,
      };
    }
    
    case 'RESET_XERO_ACCOUNT_MODAL': {
      return {
        ...INIT_STATE,
      };
    }
    default:
      return state;
  }
}
